import {createFileRoute} from '@tanstack/react-router';

import {checklistTemplateKeys} from '@/features/Library/api/queryKeys';
import {getChecklistTemplate} from '@/features/Library/api/readChecklistTemplate';
import {UpdateChecklistTemplateForm} from '@/features/Library/components/ChecklistTemplate/UpdateChecklistTemplateForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute(
  '/_b/_p/_library/checklists/update/$checklistTemplateId'
)({
  component: UpdateChecklistTemplateForm,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(`Edit ${params.checklistTemplateId}`);

    return {
      ...context,
      readChecklistTemplateQuery: {
        queryKey: checklistTemplateKeys.detail(params.checklistTemplateId),
        queryFn: () => getChecklistTemplate(params.checklistTemplateId),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(
      context.readChecklistTemplateQuery
    );
  },
});
